"use strict";
/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGING_VERSION = exports.INTERNAL_CONTRACT_VERSION = void 0;
// Export the version of the internal contract to be available at runtime
//  This file is generated by yarn publish:bump via scripts/publish-check.ts
//  updateInternalContractRuntimeVersion in the monorepo root.
const internalContractVersion = require("../internal-contract-version.json");
exports.INTERNAL_CONTRACT_VERSION = internalContractVersion;
__exportStar(require("./contract/DataTypeConverter"), exports);
__exportStar(require("./contract/Enums"), exports);
__exportStar(require("./contract/Models"), exports);
__exportStar(require("./contract/Notifications"), exports);
__exportStar(require("./contract/Parameters"), exports);
__exportStar(require("./contract/Verbs"), exports);
__exportStar(require("./interface/AskDataInterface"), exports);
__exportStar(require("./interface/InitializationOptions"), exports);
__exportStar(require("./interface/InternalApiDispatcher"), exports);
__exportStar(require("./interface/PulseInterface"), exports);
__exportStar(require("./interface/VersionNumber"), exports);
__exportStar(require("./interface/VqlInterface"), exports);
__exportStar(require("./messaging/CrossFrameMessenger"), exports);
__exportStar(require("./messaging/interface/MessageDispatcher"), exports);
__exportStar(require("./messaging/interface/MessageListener"), exports);
__exportStar(require("./messaging/interface/MessageTypes"), exports);
__exportStar(require("./messaging/interface/Messenger"), exports);
__exportStar(require("./messaging/interface/PreparedMessage"), exports);
__exportStar(require("./versioning/external/ExternalContractVersionConverter"), exports);
__exportStar(require("./versioning/external/ExternalIdentityVersionConverter"), exports);
__exportStar(require("./versioning/external/ExternalVersionConverterFactory"), exports);
__exportStar(require("./versioning/InternalContractVersionConverter"), exports);
__exportStar(require("./versioning/VersionConverterFactory"), exports);
// Export the version number of messaging for consumers to use.
// Be very careful making any updates to this contract which break version compatibility.
exports.MESSAGING_VERSION = {
    major: 1,
    minor: 0,
    fix: 0,
};
//# sourceMappingURL=JsApiInternalContract.js.map